import React, { useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {
    startOfMonth,
    endOfMonth,
    parseISO,
    max,
    min,
    differenceInSeconds,
} from 'date-fns';
import TaplrTooltip from '../../../Shared/Tooltip';
import { ArrowRight } from 'lucide-react';

// Create styles using makeStyles
const useStyles = makeStyles({
    barContainer: {
        position: 'relative',
        height: 12,
        width: '100%',
        backgroundColor: '#e0e0e0',
        borderRadius: 4,
        overflow: 'hidden',
    },
    activeSegment: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        backgroundColor: '#CFAD89',
        borderRadius: 4,
        '&:hover': {
            backgroundColor: 'var(--color-primary)',
        },
    },
});

const CompanyActivityBar = ({ activeRanges, targetMonth }) => {
    const classes = useStyles();

    const monthStart = startOfMonth(targetMonth);
    const monthEnd = endOfMonth(targetMonth);
    const totalSeconds = differenceInSeconds(monthEnd, monthStart);

    const getRangeStyles = (range) => {
        const rangeStart = parseISO(range.startDate);
        const rangeEnd = parseISO(range.endDate);

        const clampedStart = max([rangeStart, monthStart]);
        const clampedEnd = min([rangeEnd, monthEnd]);

        const startOffsetSeconds = differenceInSeconds(clampedStart, monthStart);
        const durationSeconds = differenceInSeconds(clampedEnd, clampedStart);

        const leftPercent = (startOffsetSeconds / totalSeconds) * 100;
        const widthPercent = (durationSeconds / totalSeconds) * 100;

        return {
            left: `${leftPercent}%`,
            width: `${widthPercent}%`,
        };
    };

    // format date to dd/mm hh:mm
    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${day}/${month} ${hours}:${minutes}`;
    }

    return (
        <div className={classes.barContainer}>
            {activeRanges.map((range, idx) => {
                const styles = getRangeStyles(range);
                return (
                    <TaplrTooltip title={
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#0C0E29", fontSize: "14px", fontWeight: "normal", fontFamily: "Lato, sans-serif" }}>
                            <p>{formatDate(range.startDate)}</p>
                            <ArrowRight size={16} strokeWidth={1.4} />
                            <p>{formatDate(range.endDate)}</p>
                        </div>
                    }>
                        <div
                            key={idx}
                            className={classes.activeSegment}
                            style={styles}
                        />
                    </TaplrTooltip>
                );
            })}
        </div>
    );
};

export default CompanyActivityBar;
